var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _path, _path2, _polygon, _polygon2, _path3, _g, _g2, _rect40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "859px",
    height: "462px",
    viewBox: "0 0 859 462",
    enableBackground: "new 0 0 859 462",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 330.5,
    y: 0.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "1s",
    dur: "20s",
    values: "#fff;#549D4B;#fff;#549D4B;#fff;#549D4B;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 330.5,
    y: 66.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "2s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 396.5,
    y: 66.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "4s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 462.5,
    y: 66.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "5s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 528.5,
    y: 66.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "3s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 594.5,
    y: 66.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "6s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 528.5,
    y: 132.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "10s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 594.5,
    y: 132.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "4s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 132.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 65
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "3s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 197.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "5s",
    dur: "20s",
    values: "#fff;#8ABC47;#fff;#8ABC47;#fff;#8ABC47;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 726.5,
    y: 132.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "1s",
    dur: "20s",
    values: "#fff;#3BC3DA;#fff;#3BC3DA;#fff;#3BC3DA;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 726.5,
    y: 197.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "4s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 528.5,
    y: 197.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "6s",
    dur: "20s",
    values: "#fff;#A9A8A8;#fff;#A9A8A8;#fff;#A9A8A8;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 594.5,
    y: 197.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "7s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 263.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "2s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 726.5,
    y: 263.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "4s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 792.5,
    y: 263.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "10s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 528.5,
    y: 263.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "2s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 594.5,
    y: 263.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "1s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 329.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "8s",
    dur: "20s",
    values: "#fff;#E54825;#fff;#E54825;#fff;#E54825;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 726.5,
    y: 329.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "6s",
    dur: "20s",
    values: "#fff;#C14D9C;#fff;#C14D9C;#fff;#C14D9C;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 792.5,
    y: 329.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "3s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 792.5,
    y: 395.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "4s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 528.5,
    y: 329.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "2s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 594.5,
    y: 329.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "3s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 594.5,
    y: 395.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "4s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 66.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "2s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 264.5,
    y: 66.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "7s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 132.5,
    y: 132.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "9s",
    dur: "20s",
    values: "#fff;#FEBF10;#fff;#FEBF10;#fff;#FEBF10;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 132.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "1s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 132.5,
    y: 198.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.3s",
    dur: "10s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 198.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "8s",
    dur: "20s",
    values: "#fff;#D5248F;#fff;#D5248F;#fff;#D5248F;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 132.5,
    y: 264.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "6s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 264.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "3s",
    dur: "20s",
    values: "#fff;#549D4B;#fff;#549D4B;#fff;#549D4B;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 264.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "2s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 132.5,
    y: 329.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "3s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 329.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.3s",
    dur: "20s",
    values: "#fff;#E2E2E2;#fff;#E2E2E2;#fff;#E2E2E2;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 395.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.8s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 395.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.2s",
    dur: "20s",
    values: "#fff;#FFFFFF;#fff;#FFFFFF;#fff;#FFFFFF;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M275.5,145.396v244.5H518v-244.5H275.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1082.0029,
    y1: 1251.6582,
    x2: -839.0034,
    y2: 1005.6587,
    gradientTransform: "matrix(1 0 0 -1 1358 1397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#517CBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4867AF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M507.151,145.333v55.311h8.532v15.373h-8.532v21.602h-19.164v-21.602h-32.709l-1.017-11.986 l30.39-58.697h-49.485c0.752,0.783,1.477,1.621,2.167,2.523c5.236,6.84,7.854,16.807,7.854,29.898v21.195 c0,13.139-2.606,23.104-7.821,29.898c-5.214,6.794-12.201,10.191-20.959,10.191c-8.849,0-15.893-3.396-21.128-10.191 c-5.238-6.794-7.855-16.76-7.855-29.898v-21.195c0-13.092,2.607-23.059,7.822-29.898c0.688-0.902,1.408-1.74,2.159-2.523h-27.926 v55.311h8.533v15.373h-8.533v21.602h-19.165v-21.602h-32.708l-1.016-11.986l30.388-58.697H275.5v244.5H518v-244.5h-10.849V145.333z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -1067.6357,
    y1: 1265.8496,
    x2: -824.6353,
    y2: 1019.8491,
    gradientTransform: "matrix(1 0 0 -1 1358 1397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#517CBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4867AF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_2_)",
    points: "350.313,166.581 349.907,166.513 348.891,168.342 334.06,200.644 350.313,200.644 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -997.9453,
    y1: 1334.6719,
    x2: -754.9651,
    y2: 1088.6919,
    gradientTransform: "matrix(1 0 0 -1 1358 1397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#517CBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4867AF"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_3_)",
    points: "487.987,166.581 487.581,166.513 486.564,168.342 471.734,200.644 487.987,200.644 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -1032.5039,
    y1: 1300.5605,
    x2: -789.4973,
    y2: 1054.5538,
    gradientTransform: "matrix(1 0 0 -1 1358 1397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#517CBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4867AF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M416.204,223.194h0.406c2.979,0.271,5.282-1.422,6.907-5.079c1.625-3.657,2.438-9.524,2.438-17.606 v-24.447c0-7.945-0.836-13.747-2.505-17.404c-1.671-3.656-3.996-5.371-6.976-5.146h-0.405c-3.025-0.225-5.351,1.49-6.976,5.146 c-1.625,3.657-2.438,9.459-2.438,17.404v24.447c0,8.036,0.835,13.894,2.505,17.572C410.831,221.762,413.179,223.466,416.204,223.194 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M298.879,299.523v15.067h-8.21v-41.944h14.577c4.187,0,7.49,1.235,9.91,3.711 c2.42,2.476,3.63,5.718,3.63,9.729c0,4.028-1.215,7.275-3.645,9.74c-2.43,2.466-5.728,3.697-9.896,3.697H298.879z M298.879,292.984 h6.367c1.748,0,3.083-0.646,4.004-1.935s1.383-2.926,1.383-4.907c0-2.002-0.457-3.662-1.369-4.979 c-0.912-1.317-2.252-1.978-4.019-1.978h-6.367L298.879,292.984L298.879,292.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M338.923,305.632H327.86l-2.247,8.96h-8.269l11.813-41.945h8.527l11.783,41.945h-8.268L338.923,305.632z  M329.531,299.092h7.721l-3.774-14.836h-0.173L329.531,299.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M380.177,308.369c-1.135,1.805-2.834,3.395-5.1,4.768c-2.266,1.373-5.138,2.061-8.614,2.061 c-4.494,0-8.1-1.315-10.817-3.946c-2.718-2.631-4.077-6.377-4.077-11.235v-12.791c0-4.82,1.311-8.557,3.932-11.207 c2.622-2.649,6.093-3.976,10.415-3.976c4.647,0,8.134,1.137,10.458,3.41c2.322,2.272,3.533,5.528,3.629,9.77l-0.057,0.173h-7.693 c-0.057-2.367-0.58-4.095-1.568-5.182c-0.99-1.087-2.502-1.632-4.538-1.632c-1.998,0-3.563,0.707-4.696,2.12 c-1.133,1.413-1.7,3.562-1.7,6.443v12.861c0,2.941,0.571,5.119,1.714,6.531c1.142,1.414,2.809,2.119,4.998,2.119 c1.632,0,2.838-0.222,3.616-0.662c0.777-0.441,1.416-1.096,1.916-1.959v-7.52h-5.532v-5.763h13.713L380.177,308.369 L380.177,308.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M408.668,296.184H394.58v11.868h16.564v6.54H386.37v-41.945h24.718v6.539H394.58v10.457h14.088V296.184z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M312.835,358.092H308.2l-12.668-24.854l-0.138,0.046v24.809h-4.659v-33.414h4.659l12.668,24.785 l0.138-0.047v-24.738h4.636L312.835,358.092L312.835,358.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M340.627,345.997c0,3.963-1.025,7.05-3.075,9.261c-2.05,2.211-4.796,3.315-8.239,3.315 c-3.396,0-6.097-1.104-8.101-3.315s-3.006-5.298-3.006-9.261v-9.18c0-3.947,1.006-7.038,3.018-9.271 c2.011-2.233,4.708-3.351,8.089-3.351c3.427,0,6.169,1.117,8.227,3.351c2.058,2.234,3.087,5.324,3.087,9.271V345.997z  M335.991,336.748c0-2.906-0.582-5.113-1.744-6.621c-1.163-1.506-2.808-2.26-4.934-2.26c-2.096,0-3.703,0.754-4.819,2.26 c-1.117,1.508-1.675,3.715-1.675,6.621v9.249c0,2.938,0.563,5.163,1.687,6.679c1.125,1.514,2.727,2.271,4.808,2.271 c2.142,0,3.79-0.754,4.946-2.26c1.155-1.509,1.732-3.737,1.732-6.69L335.991,336.748L335.991,336.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M364.701,328.211h-8.583v29.881h-4.659v-29.881h-8.537v-3.533h21.779V328.211z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M396.027,343.221h-12.416v14.871h-4.658v-33.414h19.07v3.533h-14.412v11.475h12.416V343.221 L396.027,343.221z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M423.634,345.997c0,3.963-1.024,7.05-3.075,9.261s-4.796,3.315-8.238,3.315 c-3.396,0-6.098-1.104-8.102-3.315c-2.005-2.211-3.007-5.298-3.007-9.261v-9.18c0-3.947,1.006-7.038,3.019-9.271 s4.709-3.351,8.09-3.351c3.428,0,6.17,1.117,8.228,3.351c2.058,2.234,3.087,5.324,3.087,9.271L423.634,345.997L423.634,345.997z  M418.999,336.748c0-2.906-0.582-5.113-1.744-6.621c-1.163-1.506-2.808-2.26-4.935-2.26c-2.097,0-3.702,0.754-4.818,2.26 c-1.117,1.508-1.676,3.715-1.676,6.621v9.249c0,2.938,0.563,5.163,1.687,6.679c1.125,1.514,2.729,2.271,4.809,2.271 c2.143,0,3.791-0.754,4.946-2.26c1.153-1.509,1.731-3.737,1.731-6.69V336.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M449.729,324.678v23.155c0,3.458-0.991,6.112-2.974,7.964c-1.981,1.852-4.569,2.776-7.768,2.776 c-3.152,0-5.7-0.925-7.644-2.776c-1.942-1.852-2.914-4.506-2.914-7.964v-23.155h4.612v23.155c0,2.387,0.535,4.185,1.606,5.394 c1.069,1.209,2.517,1.813,4.338,1.813c1.896,0,3.388-0.581,4.475-1.744c1.086-1.162,1.629-2.983,1.629-5.462v-23.155 L449.729,324.678L449.729,324.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M477.703,358.092h-4.636l-12.668-24.854l-0.139,0.046v24.809h-4.657v-33.414h4.657l12.668,24.785 l0.139-0.047v-24.738h4.636V358.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M484.22,358.092v-33.414h9.181c3.549,0,6.443,1.338,8.686,4.017c2.242,2.678,3.362,6.12,3.362,10.327v4.75 c0,4.224-1.121,7.664-3.362,10.326s-5.137,3.994-8.686,3.994H484.22z M488.878,328.211v26.346h4.36 c2.341,0,4.188-1.004,5.542-3.011c1.354-2.008,2.03-4.605,2.03-7.794v-4.805c0-3.156-0.677-5.735-2.03-7.735 c-1.354-2.001-3.201-3.001-5.542-3.001H488.878L488.878,328.211z"
  }))), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 329.5,
    fill: "#FFFFFF",
    stroke: "#A9A8A8",
    strokeMiterlimit: 10,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "remove",
    restart: "always",
    calcMode: "linear",
    additive: "replace",
    accumulate: "none",
    repeatCount: "indefinite",
    begin: "0.2s",
    dur: "20s",
    values: "#fff;#1A7F80;#fff;#1A7F80;#fff;#1A7F80;#fff;",
    attributeName: "fill",
    attributeType: "XML"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.b59b7dbcb6fd1f0ce9cba042aed55602.svg";
export { ForwardRef as ReactComponent };